import conf from "../config/api.js";
import Vue from "vue";
var moment = require("moment");
import * as axios from "axios";
import vuexStorage from "../store/index.js";
import request from "request";
import { methods } from "underscore";
import { update } from "js-md5";
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require("js-htmlencode").htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title) {
  new Vue().$notify({
    title: title,
    message: content,
    type: "error",
    position: "bottom-right",
  });
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title) {
  new Vue().$notify({
    title: title,
    message: content,
    type: "success",
  });
}
async function getThirdpartyByCU(code_client) {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/thirdparties/CU/${code_client}`,
      params: {},
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération du tiers", error);
    throw error;
  }
}

async function getThirdpartyById(id) {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/thirdparties/${id}`,
      params: {},
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération du tiers", error);
    throw error;
  }
}

async function getUsers() {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/users`,
      params: {},
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération des utilisateurs", error);
    throw error;
  }
}

async function getPointageEvents() {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/agendaevents`,
      params: {},
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération du tiers", error);
    return [];
  }
}

async function getPointageEventsByUserId(id) {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/agendaevents`,
      params: {
        sortfield: 't.datep',
        sortorder: 'DESC',
        limit: 0,
        sqlfilters: "(code:like:'AC_POINTAGE')"
      },
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    var filteredResponse = response.filter((event) => event.userownerid === id);
    return filteredResponse;
  } catch (error) {
    console.error("Erreur lors de la récupération du tiers", error);
    return [];
  }
}

async function getEventById(id) {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/agendaevents/${id}`,
      params: {},
      form: {},
      headers: { "Content-type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Error lors de la récupéraion des évênements", error);
    return [];
  }
}

async function createEvent(data){
  try{
    let body = {
      'type_code':'AC_POINTAGE',
      'code': "AC_POINTAGE",
      'label': `${data.label}`,
      'datep': `${data.datep}`,
      "userassigned": {
        [`${data.userownerid}`]: {
          "id": `${data.userownerid}`
        }
      },
      'userownerid': `${data.userownerid}`
    }
    var response = await requestApi({
      method: "POST",
      url: `/api/agendaevents`,
      headers: { "Content-type": "application/json" },
      form: body,
    });
    return response
  } catch(error){
    console.error("Erreur lors de la création de l'evenement", error);
    return null
  }
}

async function modifyEvent(id, label, datep) {
  try {
    const event = await getEventById(id);
    if (!event) {
      throw new Error('Evenement non trouvé');
    }

    const updatedEvent = {
      ...event,
      label: label,
      datep: datep
    };

    const body = {
      'label': `${updatedEvent.label}`,
      'datep': `${updatedEvent.datep}`
    };

    var response = await requestApi({
      method: "POST",
      url: `/api/agendaevents/update/${id}`,
      headers: { "Content-type": "application/json" },
      form: body,
    });

    console.log(response);
    return response;
  } catch (error) {
    console.error("Erreur lors de la modification de l'evenement", error);
    return null;
  }
}

async function deleteEvent(id){
  try{
    var response = await requestApi({method:'POST', url:`/api/delete/agendaevents/${id}`, headers:{"Content-type":"application/json"}, form:{}});
    return response;
  }catch(error){
    console.log("Erreur lors de la suppression de l'évènement", error)
    return null
  }
}


async function getUserById(id) {
  try {
    var response = await requestApi({
      method: "GET",
      url: `/api/users/${id}`,
      params: {},
      form: {},
      headers: { "Content-Type": "application/json" },
    });
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération du tiers", error);
    return [];
  }
}

async function modifyUserTempsTravail(id, horaires) {
  try {
    const user = await getUserById(id);
    if (!user) {
      throw new Error('Utilisateur non trouvé');
    }

    const updatedUser = {
      ...user,
      array_options: {
        ...user.array_options,
        options_horaire_lundi: horaires.options_horaire_lundi,
        options_horaire_mardi: horaires.options_horaire_mardi,
        options_horaire_mercredi: horaires.options_horaire_mercredi,
        options_horaire_jeudi: horaires.options_horaire_jeudi,
        options_horaire_vendredi: horaires.options_horaire_vendredi,
        options_horaire_samedi: horaires.options_horaire_samedi,
        options_horaire_dimanche: horaires.options_horaire_dimanche,
      }
    };

    const body = {
      array_options: updatedUser.array_options
    };

    var response = await requestApi({
      method: "POST",
      url: `/api/users/update/${id}`,
      headers: { "Content-type": "application/json" },
      form: body,
    });

    console.log(response);
    return response;
  } catch (error) {
    console.error("Erreur lors de la modification des horaires", error);
    return null;
  }
}

async function modifyUserState(id, state) {
  try {
    const user = await getUserById(id);
    if (!user) {
      throw new Error('Utilisateur non trouvé');
    }

    const updatedUser = {
      ...user,
      array_options: {
        ...user.array_options,
        options_travail_en_cours: state,
      }
    };

    const body = {
      array_options: updatedUser.array_options
    };

    var response = await requestApi({
      method: "POST",
      url: `/api/users/update/${id}`,
      headers: { "Content-type": "application/json" },
      form: body,
    });

    console.log(response);
    return response;
  } catch (error) {
    console.error("Erreur lors de la modification des horaires", error);
    return null;
  }
}

async function exportRapportMensuel(client) {
  const currentMonthName = moment().format("MMMM");
  const currentYear = moment().format("YYYY");
  const filename =
    "Rapport de pointage " + currentMonthName + " " + currentYear + ".xlsx";
  try {
    this.axios
      .post(
        conf.server + "/api/thirdparties/export_hours",
        { client: client },
        { withCredentials: true, responseType: "blob" }
      )
      .then((response) => {
        var link = document.createElement("a");
        link.download = filename;
        link.href = URL.createObjectURL(response.data);
        document.documentElement.appendChild(link).click();
        document.documentElement.removeChild(link);
      });
  } catch (error) {
    console.error("Erreur lors de l'export des données'", error);
    return [];
  }
}

function requestApi(options) {
  return new Promise((resolve, reject) => {
    new Vue()
      .axios({
        method: options.method,
        url: conf.server + options.url,
        params: options.params,
        data: options.form,
        headers: options.headers,
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  toasterError,
  toasterSuccess,
  getThirdpartyByCU,
  getUsers,
  getPointageEvents,
  getPointageEventsByUserId,
  getUserById,
  exportRapportMensuel,
  getThirdpartyById,
  getEventById,
  modifyEvent,
  modifyUserTempsTravail,
  createEvent,
  modifyUserState,
  deleteEvent,
};
